import React, { Component } from 'react';
import { message } from 'antd';
import { Redirect } from 'react-router-dom';
import PublicMenu from '../../components/TopMenu';
// import ReactQuill from 'react-quill';
import axios from 'axios';
import Configuration from '../../Configuration';
// import 'react-quill/dist/quill.snow.css';

class MessagesConfiguration extends Component {
  constructor() {
    super();
    this.headers = {Authorization: localStorage.getItem('visitapp:token')};
    this.state = {redirect: false, current: {}, sms_message: '', email_message: ''};
    this.validateToken = this.validateToken.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
    this.handleEmail = this.handleEmail.bind(this);
  }

  componentDidMount() {
    this.validateToken();
    this.getConfiguration();
  }

  validateToken() {
    if(!localStorage.getItem('visitapp:token'))
      this.setState({redirect: true});
    
    if(!Configuration.isInRol(localStorage.getItem('visitapp:rol'), "admin"))
      this.setState({redirect: true});
  }

  getConfiguration() {
    axios.get(`${Configuration.apiServer}/api/v1/configuration`, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos')
      
      if(resp.data === null)
        return message.warning('Petición inválida')

      this.setState({current: resp.data});
    });
  }

  handleUpdate(kind, value) {
    let sendData = {};
    sendData[kind] = value;

    axios.put(`${Configuration.apiServer}/api/v1/configuration/${kind}`, sendData, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos');
      
      if(resp.data.status === 'error')
        return message.warning('Petición inválida');

      this.getConfiguration();
    });
  }

  handleEmail(event) {
    this.setState({email_message: event.target.value});
  }

  render() {
    // Verify authentication
    if(this.state.redirect) {
      return (
        <Redirect to="/" />
      );
    }

    // Render component
    return (
      <div>
        <PublicMenu />

        <div className="container" style={{ marginTop: '30px' }}>
          <div className="d-flex justify-content-between align-items-center">
            <h3 className="text-primary" style={{ marginBottom: '0px' }}>Configuración de mensajes</h3>
          </div>

          <br/>
          
          <table className="table">
            <tbody>
              <tr>
                <td>Email que envía</td>
                <td>
                  <input type="text" className="form-control" key={`emailSender:${this.state.current.id}`} defaultValue={this.state.current.email_sender} onChange={(value) => { if(value.target.value) { this.handleUpdate('email_sender', value.target.value) } }} />
                </td>
              </tr>
              <tr>
                <td>Título del Email</td>
                <td>
                  <input type="text" className="form-control" key={`emailSubject:${this.state.current.id}`} defaultValue={this.state.current.email_subject} onChange={(value) => { if(value.target.value) { this.handleUpdate('email_subject', value.target.value) } }} />
                </td>
              </tr>
              {/* <tr>
                <td>Mensaje de Email</td>
                <td>
                  <ReactQuill value={this.state.current.email_message} modules={modules} onChange={this.handleUpdate} />
                  <button className="btn btn-sm btn-primary" style={{ marginTop: '5px' }}>Actualizar</button>
                </td>
              </tr> */}
              <tr>
                <td>Mensaje de SMS</td>
                <td>
                <input type="text" className="form-control" key={`smsMessage:${this.state.current.id}`} defaultValue={this.state.current.sms_message} onChange={(value) => { if(value.target.value) { this.handleUpdate('sms_message', value.target.value) } }} />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

export default MessagesConfiguration;



// WEBPACK FOOTER //
// ./src/pages/admin/MessagesConfig.js